import { RootState } from "../Store";

export const selectLoading = (state: RootState) => state.loading.loading;